import { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import {Send2FACode, AddIpToWhiteListService} from "../../services/apiRequests";
import { apiIntranet } from '../../services/axios';
import { useTranslation } from 'react-i18next';
import '../../App.css';

const CHECK_2FA_URL = '/check2FA';

const TwoFactorAuth = (props) => {

  const { t } = useTranslation();
  const [code, setTfaCode] = useState('');
  const [errMsg, setErrMsg] = useState('');
  const [addIpToWhiteList, setAddIpToWhiteList] = useState(false);

  const [apiResponse, setApiResponse] = useState({
    status: null, // 0: ok, 1: error en API, 2: error en request -->HABRÁ QUE CONVERTIRLO EN UN HOOK, para reusarlo
    errorCode: null,
    message: []
  });

  useEffect(() => {
    setErrMsg('');
  }, [code])

  const handleApiResponse = (e) => setApiResponse({
    ...apiResponse,
    status: e.status,
    errorCode: e.errorCode,
    message: e.message,
  })

  useEffect(() => {
    Send2FACode({ loginParameters: props.loginParameters, fetchApiResponse: handleApiResponse, apiResponse: apiResponse });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await apiIntranet.post(CHECK_2FA_URL,
        { code: code }, {
        headers: {
          'Authorization': `Bearer ${props.loginParameters.accesToken}`
        }
      }
      );
      if (response?.data?.errorCode === 0) {
        props.setLoginParameters({
          is2FAValidated: 1,
        });
        if (addIpToWhiteList) {
          AddIpToWhiteListService({ loginParameters: props.loginParameters});
        }
      }
      else {
        setErrMsg('código erróneo');
      }
    } catch (err) {
      if (!err?.response) {
        setErrMsg('No Server Response');
      } else if (err.response?.status === 400) {
        setErrMsg('Missing Username or Password');
      } else if (err.response?.status === 401) {
        setErrMsg('Unauthorized');
      } else {
        setErrMsg('Login Failed');
      }
    }
  }

  const handleCheckBoxChange = () => {
    setAddIpToWhiteList(!addIpToWhiteList);
  };

  return (
    <Container id="main-container" className="d-grid h-100">
      <Form onSubmit={handleSubmit} id="sign-in-form" className="text-center p-3 w-100">
        <h1 className="mb-3 fs-3 fw-normal">{t('two_factor_auth.main_message')}</h1>

        <Form.Group className="mb-3" controlId="sign-in-TFA">
          <Form.Control
            type="number"
            size="lg"
            placeholder={t('two_factor_auth.place_holder')}
            autoComplete="off"
            className="position-relative"
            onChange={(e) => setTfaCode(e.target.value)}
            required
          />
          {/* <Form.Text className="text-muted">
            (Ejemplo de text-muted en un Form Group)
          </Form.Text> */}

          <Form.Group className="d-flex justify-content-center mt-4 mb-4" controlId="remember-me">
            <Form.Check
              label={t('two_factor_auth.checkbox_message')}
              value={addIpToWhiteList}
              onChange={handleCheckBoxChange}
            />
          </Form.Group>

        </Form.Group>

        <h4>{errMsg}</h4>

        <div className="d-grid">
          <Button type="submit" variant="primary" size="lg">{t('submit')}</Button>
        </div>

        <p className="mt-5 text-muted">&copy; Blopadev 2022</p>
      </Form>
    </Container>
  )
}

export default TwoFactorAuth
